<template>
  <div
    class="modal fade"
    id="shopperApprovalModal"
    data-backdrop="static"
    data-keyboard="false"
  >
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-hidden="true"
          >
            ×
          </button>
          <h4 class="modal-title">
            <b>{{ lang.SAM000 }}</b>
          </h4>
        </div>
        <div class="modal-body">
          <div class="table-container">
            <table class="table">
              <thead>
                <tr>
                  <th style="width: 35%">{{ lang.SAM001 }}</th>
                  <th class="text-center" style="width: 35%">
                    {{ lang.SAM002 }}
                  </th>
                  <th class="text-center" style="width: 15%">
                    {{ lang.SAM003 }}
                  </th>
                  <th class="text-center" style="width: 15%">
                    {{ lang.SAM004 }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="proposal in check.ShopperProposals"
                  :key="proposal.ShopperProposalGuid"
                >
                  <td class="text-left">
                    <div>
                      {{ lang.SAM005 }}:
                      <b>{{ proposal.ShopperId }}</b>
                    </div>
                    <div>
                      {{ lang.SAM006 }} ({{ lang.SAM007 }}):
                      <b>{{ proposal.DisplayName }}</b>
                    </div>
                    <div>
                      {{ lang.SAM008 }}:
                      <b>{{ proposal.Gender }}</b>
                    </div>
                    <div>
                      {{ lang.SAM009 }}:
                      <b>{{ proposal.Distance }} km</b>
                    </div>
                    <div v-show="proposal.Profession">
                      {{ lang.SAM010 }}:
                      <b>{{ proposal.Profession }}</b>
                    </div>
                    <div>
                      {{ lang.SAM011 }}:
                      <b>{{ proposal.CarModelName }}</b>
                    </div>
                    <div>
                      {{ lang.SAM012 }}:
                      <b>{{ proposal.CarSegmentName }}</b>
                    </div>
                    <div>
                      {{ lang.SAM013 }}:
                      <b>{{ proposal.ShopperCar }}</b>
                    </div>
                    <div>
                      {{ lang.SAM014 }}:
                      <b>
                        <span v-if="proposal.CarMatch === '-'"
                          >- {{ lang.SAM015 }}</span
                        >
                        <span v-else-if="proposal.CarMatch === '='"
                          >= {{ lang.SAM016 }}</span
                        >
                        <span v-else-if="proposal.CarMatch === '+'"
                          >+ {{ lang.SAM017 }}</span
                        >
                      </b>
                    </div>
                    <div>
                      {{ lang.SAM018 }}:
                      <b>{{ proposal.LastUpdatedAt }}</b>
                    </div>
                  </td>
                  <td class="text-left">
                    <div
                      class="comment-type-container"
                      v-if="globals.isLeadAgencyUser"
                    >
                      <a
                        class="comment-type-header"
                        @click="showFeed(proposal, 'Agency')"
                        >{{ lang.SAM019 }}</a
                      >
                      <div
                        class="last-comment-container"
                        v-if="proposal.LastCommentLeadLocal"
                      >
                        <b>{{ proposal.LastCommentLeadLocalCreatedBy }}:</b>
                        {{
                          globals.truncateString(
                            proposal.LastCommentLeadLocal,
                            120
                          )
                        }}
                      </div>
                    </div>
                    <div class="comment-type-container">
                      <a
                        class="comment-type-header"
                        @click="showFeed(proposal, 'Audi')"
                        >{{ globals.isAudiUser ? lang.SAM021 : lang.SAM020 }}</a
                      >
                      <div
                        class="last-comment-container"
                        v-if="proposal.LastCommentLeadAudi"
                      >
                        <b>{{ proposal.LastCommentLeadAudiCreatedBy }}:</b>
                        {{
                          globals.truncateString(
                            proposal.LastCommentLeadAudi,
                            120
                          )
                        }}
                      </div>
                    </div>
                  </td>
                  <td>
                    <div class="form-group">
                      <select
                        class="form-control"
                        v-model="proposal.AgencyApprovalStatus"
                        @change="updateApprovalState(proposal, 'leadAgency')"
                        :disabled="
                          !globals.isAgencyUser ||
                          proposal.MainEntityApprovalStatus
                        "
                        :class="{
                          'option-green':
                            proposal.AgencyApprovalStatus === 'Approved',
                          'option-red':
                            proposal.AgencyApprovalStatus === 'Rejected',
                          'option-yellow': !proposal.AgencyApprovalStatus,
                        }"
                      >
                        <option class="option-green" :value="'Approved'">
                          {{ lang.SAM022 }}
                        </option>
                        <option class="option-yellow" :value="undefined">
                          {{ lang.SAM023 }}
                        </option>
                        <option class="option-red" :value="'Rejected'">
                          {{ lang.SAM024 }}
                        </option>
                      </select>
                    </div>
                  </td>
                  <td>
                    <div class="form-group">
                      <select
                        class="form-control"
                        v-model="proposal.MainEntityApprovalStatus"
                        @change="updateApprovalState(proposal, 'mainEntity')"
                        :disabled="
                          !globals.isAudiUser ||
                          proposal.AgencyApprovalStatus !== 'Approved'
                        "
                        :class="{
                          'option-green':
                            proposal.MainEntityApprovalStatus === 'Approved',
                          'option-red':
                            proposal.MainEntityApprovalStatus === 'Rejected',
                          'option-yellow': !proposal.MainEntityApprovalStatus,
                        }"
                      >
                        <option
                          class="option-green"
                          :value="'Approved'"
                          v-if="
                            !anyShopperAlreadyApproved ||
                            proposal.MainEntityApprovalStatus === 'Approved'
                          "
                        >
                          {{ lang.SAM022 }}
                        </option>
                        <option class="option-yellow" :value="undefined">
                          {{ lang.SAM023 }}
                        </option>
                        <option class="option-red" :value="'Rejected'">
                          {{ lang.SAM024 }}
                        </option>
                      </select>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-raised" data-dismiss="modal">
            {{ lang.SAM025 }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ShopperApprovalModal",
  props: {
    showModal: {
      type: Boolean,
      default: false,
    },
    check: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      lang: {
        SAM000: "Shopper Approval",
        SAM001: "Shopper",
        SAM002: "Messages",
        SAM003: "Lead Approval",
        SAM004: "Audi Approval",
        SAM005: "ShopperID",
        SAM006: "Name",
        SAM007: "Age",
        SAM008: "Gender",
        SAM009: "Distance",
        SAM010: "Profession",
        SAM011: "Model",
        SAM012: "Segment",
        SAM013: "Car",
        SAM014: "Match",
        SAM015: "Downgrade",
        SAM016: "Match",
        SAM017: "Upgrade",
        SAM018: "Last update",
        SAM019: "Agency Channel",
        SAM020: "Audi Channel",
        SAM021: "Conversation",
        SAM022: "approved",
        SAM023: "open",
        SAM024: "rejected",
        SAM025: "Close",
        SAM026: "Approval updated",
        SAM027: "Approval update failed",
      },
    };
  },
  computed: {
    anyShopperAlreadyApproved() {
      if (!this.check.ShopperProposals) return false;
      return (
        _.findIndex(
          this.check.ShopperProposals,
          (proposal) => proposal.MainEntityApprovalStatus === "Approved"
        ) > -1
      );
    },
  },
  watch: {
    "globals.selectedLanguage"() {
      this.globals.getLanguageStrings(this);
    },
    showModal(newVal) {
      newVal ? this.openModal() : this.closeModal();
    },
  },
  mounted() {
    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);

    $("#shopperApprovalModal").on("hidden.bs.modal", (e) =>
      this.$emit("modalClosed")
    );
  },
  methods: {
    openModal() {
      this.getLastFeedComments();
      $("#shopperApprovalModal").modal("show");
    },
    closeModal() {
      $("#shopperApprovalModal").modal("hide");
    },
    showFeed(proposal, type) {
      this.globals.$off("feedModalClosed");
      this.globals.$once("feedModalClosed", (itemGuid, posts) => {
        if (posts[0] && posts[0].Content) {
          if (type === "Audi") {
            proposal.LastCommentLeadAudi = posts[0].Content;
            proposal.LastCommentLeadAudiCreatedBy =
              posts[0].FeedPostCreatedBy.Username;
          } else {
            proposal.LastCommentLeadLocal = posts[0].Content;
            proposal.LastCommentLeadLocalCreatedBy =
              posts[0].FeedPostCreatedBy.Username;
          }
          this.$forceUpdate();
        }
      });

      let feedName =
        type === "Audi" ? "LeadAgencyAudi" : "LeadAgencyLocalAgency";
      this.globals.$emit("openFeedModal", {
        ItemGuid: proposal.ShopperProposalGuid,
        FeedType: "ShopperProposal",
        FeedName: feedName,
      });
    },
    getLastFeedComments() {
      let requestCount = this.check.ShopperProposals.length;
      if (this.globals.isLeadAgencyUser) requestCount *= 2;

      this.globals.$off("feedPostsReceived");
      this.globals.$on("feedPostsReceived", (itemGuid, feedName, posts) => {
        if (posts[0] && posts[0].Content) {
          let proposal = _.find(
            this.check.ShopperProposals,
            (p) => p.ShopperProposalGuid === itemGuid
          );
          if (feedName === "LeadAgencyAudi") {
            proposal.LastCommentLeadAudi = posts[0].Content;
            proposal.LastCommentLeadAudiCreatedBy =
              posts[0].FeedPostCreatedBy.Username;
          } else if (feedName === "LeadAgencyLocalAgency") {
            proposal.LastCommentLeadLocal = posts[0].Content;
            proposal.LastCommentLeadLocalCreatedBy =
              posts[0].FeedPostCreatedBy.Username;
          }
        }

        if (--requestCount <= 0) {
          this.globals.$off("feedPostsReceived");
          this.$forceUpdate();
        }
      });

      for (let proposal of this.check.ShopperProposals) {
        if (this.globals.isLeadAgencyUser)
          this.globals.$emit("requestFeedPosts", {
            ItemGuid: proposal.ShopperProposalGuid,
            FeedType: "ShopperProposal",
            FeedName: "LeadAgencyLocalAgency",
          });
        this.globals.$emit("requestFeedPosts", {
          ItemGuid: proposal.ShopperProposalGuid,
          FeedType: "ShopperProposal",
          FeedName: "LeadAgencyAudi",
        });
      }
    },
    updateApprovalState(proposal, approvalSource) {
      let query = `api/Approval/ShopperApproval/${proposal.ShopperProposalGuid}`;
      let body = {
        ShopperApprovalType: "Reset",
      };
      let approvalState;
      if (approvalSource === "leadAgency")
        approvalState = proposal.AgencyApprovalStatus;
      else approvalState = proposal.MainEntityApprovalStatus;

      if (approvalState === "Approved") body.ShopperApprovalType = "Approve";
      else if (approvalState === "Rejected")
        body.ShopperApprovalType = "Reject";

      $.ajax({
        method: "POST",
        url: query,
        data: JSON.stringify(body),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: (data) => {
          if (data.Error) {
            this.globals.showErrorSnackbar(data.Error);
            console.error(data.Error);
            this.$emit("resetData");
            return;
          }
          this.globals.showSuccessSnackbar(this.lang.SAM026);
        },
        error: (error) => {
          console.error("Error on POST in updateApprovalState()");
          this.globals.showErrorSnackbar(this.lang.SAM027);
          this.$emit("resetData");
        },
      });
    },
  },
};
</script>

<style scoped>
.modal-lg {
  width: 1200px;
}
.modal-body {
  padding: 10px;
}
.modal-body > .table-container {
  max-height: calc(100vh - 175px);
  overflow: auto;
}

.table td > .form-group {
  margin: 0 15%;
}
.option-green {
  background-color: rgb(154, 236, 154) !important;
}
.option-yellow {
  background-color: rgb(228, 228, 110) !important;
}
.option-red {
  background-color: rgb(238, 155, 155) !important;
}
.form-group > select.form-control {
  border-radius: 5px;
}
.form-group > select.form-control:disabled {
  opacity: 0.7;
}

.table .btn {
  margin: 5px;
  padding: 2px 10px;
}
.comment-type-header {
  font-weight: bold;
  color: #004080;
  cursor: pointer;
}
.comment-type-container {
  border: 2px solid lightgray;
  border-radius: 10px;
  padding: 5px;
  margin-bottom: 10px;
  text-align: center;
}
.last-comment-container {
  margin-top: 5px;
  padding: 2px 5px;
  border: 1px solid lightgray;
  border-radius: 5px;
  min-height: 50px;
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// ShopperApprovalModal.vue?4daff312